import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../pages/login/Login'
import Layout from '../layout/Layout'
import Dashboard from '../pages/dashboard/Dashboard'
import Forms from '../pages/forms/Forms'
import RenderForm from '../pages/renderForm/RenderForm'
import Guard from '../pages/guard/Guard'
import Demo from '../pages/demo/Demo'
import Configuration from '../pages/configuration/Configuration'
import Invitation from '../pages/invitation/Invitation'
import VisitInvitation from '../pages/visit_invitation/VisitInvitation'
import Kiosk from '../pages/kiosk/Kiosk'
import VisitMonitor from '../pages/visit_monitor/VisitMonitor'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/app',
    name: 'Layout',
    component: Layout,
    children: [
      // main pages
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "forms",
        name: "Forms",
        component: Forms
      },
      {
        path: "guard",
        name: "Guard",
        component: Guard
      },
      {
        path: 'kiosk',
        name: 'Kiosk',
        component: Kiosk
      },
      {
        path: 'visit-monitor',
        name: 'VisitMonitor',
        component: VisitMonitor
      },
      {
        path: "configuration",
        name: "Configuration",
        component: Configuration
      }
    ]
  },
  {
    path: '/f',
    name: 'RenderForm',
    component: RenderForm
  },
  {
    path: '/demo',
    name: 'Demo',
    component: Demo
  },
  {
    path: '/invitation',
    name: 'Invitation',
    component: Invitation
  },
  {
    path: '/v',
    name: 'VisitInvitation',
    component: VisitInvitation
  },
  /*,
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" '../views/About.vue')
  }*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
